import { render, staticRenderFns } from "./ElementsTextPreview.vue?vue&type=template&id=61fe2ef1"
import script from "./ElementsTextPreview.vue?vue&type=script&lang=js"
export * from "./ElementsTextPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports